<template>
  <b-row class="match-height">
    <b-col
      lg="6"
      md="12"
      sm="12"
    >
      <b-card style="background-color: rgb(255, 127, 96, 0.0); width: 100%; height: auto; border: 2px solid #00B058; border-radius: 40px 4px 40px 4px;">
        <span style="color:#ffffff;font-size:24px; margin-left:10px">สัดส่วนกล้องโทรทัศน์วงจรปิด</span>
        <div class="pie-text text-center">
          <h3 class="font-weight-bold">
            โดยรวม
          </h3>
          <h2 class="font-weight-bolder">
            {{ camTotal.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}
          </h2>
        </div>

        <div class="chart">
          <app-echart-doughnut :series="series" />
        </div>
      </b-card>
    </b-col>
    <b-col
      lg="6"
      md="12"
      sm="12"
    >
      <b-card style="background-color: rgb(255, 127, 96, 0.0); width: 100%; height: auto; border: 2px solid #00B058; border-radius: 40px 4px 40px 4px;">
        <span style="color:#ffffff;font-size:24px; margin-left:10px">5 Top จุดติดตั้งกล้องโทรทัศน์สูงสุด</span>
        <b-row
          v-for="(item, index) in progress.slice(0,5)"
          :key="index"
          style="margin-top:10px"
          class="mt-2"
        >
          <b-col
            lg="10"
          >
            <label style="color: #ffffff; font-size: 18px;">{{ index+1 +'. ' }} {{ item.WayID }}</label>
            <b-progress
              :value="item.Total"
              max="500"
              precision="2"
              class="progress8"
            />
          </b-col>
          <b-col
            lg="2"
            style="text-align: left;"
          >
            <br>
            <span style="color:#ffffff; ">{{ item.Total }} กล้อง</span>
          </b-col>
        </b-row>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow, BCol, BProgress, BCard,
} from 'bootstrap-vue'
import axios from '@axios'
import AppEchartDoughnut from './AppEchartDoughnut.vue'

export default {
  components: {
    BRow,
    BCol,
    AppEchartDoughnut,
    BProgress,
    BCard,
  },
  data() {
    return {
      progress: [],
      camTotal: '',
      series: [
        {
          color: ['#579BFE', '#DC48FF', '#8246FE', '#FE447A', '#4EAF51', '#FF805D', '#FDFF01'],
          name: 'Visit source',
          type: 'pie',
          radius: ['50%', '70%'],
          avoidLabelOverlap: true,
          label: {
            show: true,
            fontSize: '14',
            formatter: ' {b}: {c} ',
          },
          labelLine: {
            show: true,
          },
          data: [],
        },
      ],
      userData: JSON.parse(localStorage.getItem('userData')),
    }
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  mounted() {
    this.getSumCCTV()
    this.getPieData()
    this.getTop5()
    this.interval = setInterval(() => {
      this.getSumCCTV()
      this.getPieData()
      this.getTop5()
    }, 300000)
  },
  methods: {
    getSumCCTV() {
      axios
        .post('/getSumCCTVTotal', { department: this.userData.department, username: this.userData.username })
        .then(response => {
          this.total = response.data[0].Total
          this.online = response.data[0].Online
          this.offline = response.data[0].Offline
        })
        .catch(error => {
          console.log(error)
        })
    },
    getPieData() {
      axios
        .post('/getPercentCCTVTotal', { department: this.userData.department, username: this.userData.username })
        .then(response => {
          // eslint-disable-next-line prefer-destructuring
          this.series[0].data = response.data[0]
          // eslint-disable-next-line prefer-destructuring
          this.camTotal = response.data[1][0].cam_total
        })
        .catch(error => {
          console.log(error)
        })
    },
    getTop5() {
      axios
        .post('/getTop5CCTVTotal', { department: this.userData.department, username: this.userData.username })
        .then(response => {
          // eslint-disable-next-line prefer-destructuring
          this.progress = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },
  },
}
</script>

<style scoped lang="scss">
  .pie-text{
      width: 200px;
      position:absolute;
      margin: auto;
      left: 0;
      right: 0;
      top: 45%;
      bottom: 0;
    }

  .progress8 .progress-bar{background: linear-gradient(90deg, #00B058 46.03%, #99FBCA 100%)}

.br {
      display: block;
      margin-bottom: 0em;
    }
  </style>
